import React from 'react';
import type { Campaign, CampaignBanner } from '../../../../types';
import PromoBanner from '../../../../components/campaign-banners/promo-banner';
import { getCampaignPromoBanners } from '../../utils';

const ProductBeforePromoBanner: React.FC<
  React.PropsWithChildren<
    React.PropsWithChildren<IProductBeforePromoBannerProps>
  >
> = props => {
  const { campaignBanners } = props;
  const campaignPromoBanners = getCampaignPromoBanners(campaignBanners);
  return campaignPromoBanners.before &&
    campaignPromoBanners.before.length > 0 ? (
    <PromoBanner inverted banners={campaignPromoBanners.before} />
  ) : null;
};

interface IProductBeforePromoBannerProps {
  campaignBanners: {
    active: (CampaignBanner & {
      campaign: Pick<Campaign, 'media'>;
    })[];
  };
}

export default ProductBeforePromoBanner;
